/**
 * RouterContainer component.
 */
import styled from 'styled-components';

const RouterContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
`;

export default RouterContainer;
